import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';
import { useYotpoWidget } from './Yotpo';

export const ReviewWrapper = styled('div')`
  width: 100%;
  margin: auto;
  text-align: center;
  word-break: normal;
  margin-top: 100px;
  display: block;

  ${theme.below.lg} {
    width: 90vw;
    margin-top: 40px;

    .yotpo .promoted-products-box .promoted-products {
      overflow: hidden;
      overflow-x: scroll;
    }
    .yotpo .promoted-products-box .yotpo-promoted-products {
      width: 100%;
      margin: auto !important;
    }
    .yotpo .promoted-products-box .promoted-products li {
      width: 45%;
    }
  }

  .yotpo .promoted-products-box .yotpo-main-title {
    text-align: center;
    color: black;
    text-transform: uppercase;
    margin-bottom: 0;
  }

  .yotpo .promoted-products-box .promoted-products li {
    width: 16.5%;
    padding: 5px;
    ${theme.below.lg} {
      width: 40%;
    }
  }
  .yotpo .promoted-products-box .promoted-products .yotpo-promoted-product {
    margin: 0 !important;
    width: 100%;
  }
  .yotpo
    .promoted-products-box
    .promoted-products
    .yotpo-promoted-product
    .yotpo-product-name {
    margin-bottom: 5px;
    font-size: 12px;
    line-height: 1.3;
    font-weight: 300;
    text-align: left;
    text-transform: uppercase;
    color: #000;
  }
  .yotpo
    .promoted-products-box
    .promoted-products
    .yotpo-promoted-product
    .yotpo-product-image {
    text-align: center;
    position: relative;
    padding: 10px;
    height: auto !important;
    min-width: 0;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.02);
      z-index: 1;
      pointer-events: none;
    }

    img {
      width: 100%;
      max-width: 100%;
      height: auto;
      max-height: none;
    }
  }
  .yotpo
    .promoted-products-box
    .promoted-products
    .yotpo-promoted-product
    .yotpo-review-stars {
    transform: scale(0.9);
    margin-left: -5px;
  }
`;

export const ProductReviews = ({ product }) => {
  const loaded = useYotpoWidget();

  return (
    <>
      <div className="yotpo-reviews" />
      {loaded ? (
        <ReviewWrapper>
          <div
            className="yotpo yotpo-main-widget"
            data-product-id={product.id}
            data-price={product.price.incVat}
            data-currency="NOK"
            data-name={product.name}
            data-url={product.primaryRoute.path}
            data-image-url={product.images.url}
            data-description={product.description}
          ></div>
        </ReviewWrapper>
      ) : null}
    </>
  );
};

export default ProductReviews;
